module.exports = __webpack_public_path__ + "static/media/downloadresource.79b7ce55.svg";